import styled from 'styled-components'
import WishButton from 'uiComponents/atoms/WishButton/WishButton'

const ProductTileWishlistButton = styled(WishButton)<{ $isRTL?: boolean }>`
  width: 36px;
  height: 36px;
  padding: 5px;
  position: absolute;
  top: 15px;
  right: 15px;
  &.mdc-ripple-surface {
    position: absolute;

    &::before {
      ${({ $isRTL }) => ($isRTL ? 'right: 6px' : 'left: 6px')};
    }
  }
`

export default ProductTileWishlistButton
